<div id="app">
  @if (shouldShowMainNavbar()) {
    <nav class="navbar navbar-expand-lg app-navbar">
      <div class="container-fluid app-navbar-shell">
        <button class="navbar-toggler app-navbar-toggler" type="button" (click)="myFunction()" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarNavDropdown">
          <ul class="navbar-nav app-navbar-nav">
            <li class="nav-item" routerLinkActive="app-nav-item-active" [routerLinkActiveOptions]="{ exact: true }">
              @if (showAdminBoard) {
                <a class="nav-link app-nav-link" routerLink="/admin">Global</a>
              }
            </li>
            <li class="nav-item" routerLinkActive="app-nav-item-active" [routerLinkActiveOptions]="{ exact: true }">
              @if (showStudentBoard) {
                <a class="nav-link app-nav-link" routerLink="/my-board">Mon bord</a>
              }
            </li>
            <li class="nav-item" routerLinkActive="app-nav-item-active" [routerLinkActiveOptions]="{ exact: true }">
              @if (showMonitorBoard && (!showAdminBoard || isReadOnly)) {
                <a class="nav-link app-nav-link" routerLink="/monitor-calendar">Mon Plannig</a>
              }
            </li>
            <li class="nav-item" routerLinkActive="app-nav-item-active">
              @if (showAdminBoard) {
                <a class="nav-link app-nav-link" routerLink="/calendar">Calendrier</a>
              }
              @if (showStudentBoard) {
                <a class="nav-link app-nav-link" routerLink="/my-calendar">Mes Heures</a>
              }
            </li>
            <li class="nav-item" routerLinkActive="app-nav-item-active">
              @if (showStudentBoard) {
                <a class="nav-link app-nav-link" routerLink="/my-drive">Suivi Drive</a>
              }
            </li>
            @if (showAdminBoard) {
              <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle app-nav-link" id="student-navbar" role="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  Eléves
                </a>
                <div class="dropdown-menu app-dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                  <a class="dropdown-item app-dropdown-item" routerLink="/students">Liste des éléves</a>
                  @if (!isReadOnly) {
                    <a class="dropdown-item app-dropdown-item" routerLink="/new-student">Créé un éléve</a>
                  }
                  <a class="dropdown-item app-dropdown-item" routerLink="/students-archived">Elèves archivés</a>
                </div>
              </li>
            }
            @if (showAdminBoard) {
              <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle app-nav-link" id="monitor-navbar" role="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  Équipe
                </a>
                <div class="dropdown-menu app-dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                  <a class="dropdown-item app-dropdown-item" routerLink="/monitors">Liste des moniteurs</a>
                  @if (!isReadOnly) {
                    <div class="dropdown-divider"></div>
                  }
                  @if (!isReadOnly) {
                    <a class="dropdown-item app-dropdown-item" routerLink="/users">Comptes utilisateurs</a>
                  }
                </div>
              </li>
            }
            <li class="nav-item" routerLinkActive="app-nav-item-active">
              @if (showAdminBoard) {
                <a class="nav-link app-nav-link" routerLink="/configurations">Configurations</a>
              }
            </li>
            <li class="nav-item" routerLinkActive="app-nav-item-active">
              @if (showAdminBoard && isSuperAdmin) {
                <a class="nav-link app-nav-link" routerLink="/payments">Paiements</a>
              }
            </li>
            <li class="nav-item" routerLinkActive="app-nav-item-active">
              @if (showAdminBoard) {
                <a class="nav-link app-nav-link" routerLink="/purchases">Dépenses</a>
              }
            </li>
            <li class="nav-item" routerLinkActive="app-nav-item-active">
              @if (showAdminBoard) {
                <a class="nav-link app-nav-link" routerLink="/events-history">Historique</a>
              }
            </li>
            <li class="nav-item">
              @if (showAdminBoard && !isReadOnly) {
                <a class="nav-link app-nav-link app-nav-link--accent" data-bs-toggle="modal" data-bs-target="#expenseModal">
                  <i class="fa fa-plus" aria-hidden="true"></i> Ajouter Dépense
                </a>
              }
            </li>
            @if (!isLoggedIn && navMobile) {
              <a class="nav-link app-nav-link app-nav-link--right" routerLink="/login">Connexion</a>
            }
            @if (isLoggedIn && navMobile) {
              <a class="nav-link app-nav-link app-nav-link--right" routerLink="/profile">{{ username }}</a>
            }
            @if (isLoggedIn && navMobile) {
              <a href class="nav-link app-nav-link app-nav-link--right" (click)="logout()">Se Déconnecter</a>
            }
          </ul>
        </div>
        @if (!navMobile) {
          <form class="form-inline app-navbar-actions">
            @if (!isLoggedIn) {
              <a class="nav-link app-nav-link app-nav-link--right" routerLink="/login">Connexion</a>
            }
            @if (isLoggedIn) {
              <a class="nav-link app-nav-link app-nav-link--right" routerLink="/profile">{{ username }}</a>
            }
            @if (isLoggedIn) {
              <a href class="nav-link app-nav-link app-nav-link--right" (click)="logout()">Se Déconnecter</a>
            }
          </form>
        }
      </div>
    </nav>
  }

  <router-outlet></router-outlet>

  <!-- Modal -->
  <div class="modal fade" id="expenseModal" tabindex="-1" role="dialog" aria-labelledby="expenseModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="expenseModalLabel">Ajouter une dépense</h5>
          <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form [formGroup]="expenseForm" (ngSubmit)="onSubmit()">
            <div class="form-group">
              <label for="date">Date</label>
              <input type="date" class="form-control" id="date" formControlName="date">
            </div>
            <div class="form-group">
              <label for="product">Mode de paiement</label>
              <select class="form-control" id="payment" formControlName="paymentMethod">
                @for (payment of paymentMethods; track payment) {
                  <option [value]="payment">{{ payment }}</option>
                }
              </select>
            </div>
            <div class="form-group">
              <label for="price">Prix</label>
              <input type="number" class="form-control" id="price" formControlName="cost" placeholder="Quel est le montant ?">
            </div>
            <div class="form-group">
              <label for="product">Raison</label>
              <select class="form-control" id="product" formControlName="reason">
                @for (product of products; track product) {
                  <option [value]="product">{{ product }}</option>
                }
              </select>
            </div>
            <div class="form-group">
              <label for="description">Description</label>
              <textarea class="form-control" id="description" formControlName="description" rows="3"></textarea>
            </div>
            <button type="submit" class="btn btn-primary">Enregistrer</button>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
        </div>
      </div>
    </div>
  </div>


</div>
